import React, { createContext, useState, useContext, useMemo, useEffect, useRef } from 'react';

const LayoutContext = createContext(null);

// Görgetési pozíciót szándékosan NEM tárolunk itt: minden scroll eseménynél új context-érték
// az összes fogyasztót (Header, Home, ServiceProviders) újrarenderelte, ami görgetéskor
// akadozást és kirajzolatlan (üres hátterű) területeket okozott. Akinek kell, figyelje helyben.
export const LayoutProvider = ({ children }) => {
  const [headerVisible, setHeaderVisible] = useState(true);
  const [isHeaderTransparent, setIsHeaderTransparent] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0); // ÚJ: Fejléc magasságának állapota
  const headerRef = useRef(null); // ÚJ: Ref a fejléc DOM elemének referenciájához

  // ÚJ: Effect a fejléc magasságának mérésére
  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
    // Figyeljük a headerRef.current változását, ha a komponens újramountolódik,
    // vagy a headerVisible állapotot, ha az befolyásolhatja a magasságot.
  }, [headerRef.current, headerVisible]);


  const value = useMemo(() => ({
    headerVisible,
    setHeaderVisible,
    isHeaderTransparent,
    setIsHeaderTransparent,
    headerHeight, // ÚJ: Hozzáadjuk a headerHeight-et a context-hez
    headerRef,    // ÚJ: Hozzáadjuk a headerRef-et a context-hez
  }), [headerVisible, isHeaderTransparent, headerHeight]); // ÚJ: Függőségek frissítése

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};